import { createStore } from 'vuex'
import horses from './modules/horses'
import race from './modules/race'

export default createStore({
  modules: {
    horses,
    race
  },
  state: {
    appName: 'Horse Racing'
  },
  getters: {
    appName: state => state.appName
  },
  strict: process.env.NODE_ENV !== 'production'
})
